// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Monitor a node via an OPC UA subscription. Nodes sharing a
 * `subscription_name` are grouped into a single server-side Subscription.
 */
export class SubscribeMode implements flatbuffers.IUnpackableObject<SubscribeModeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SubscribeMode {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSubscribeMode(bb: flatbuffers.ByteBuffer, obj?: SubscribeMode): SubscribeMode {
    return (obj || new SubscribeMode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSubscribeMode(
    bb: flatbuffers.ByteBuffer,
    obj?: SubscribeMode,
  ): SubscribeMode {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SubscribeMode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  subscriptionName(): string;
  subscriptionName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  subscriptionName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startSubscribeMode(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addSubscriptionName(
    builder: flatbuffers.Builder,
    subscriptionNameOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, subscriptionNameOffset, 0);
  }

  static endSubscribeMode(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // subscription_name
    return offset;
  }

  static createSubscribeMode(
    builder: flatbuffers.Builder,
    subscriptionNameOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SubscribeMode.startSubscribeMode(builder);
    SubscribeMode.addSubscriptionName(builder, subscriptionNameOffset);
    return SubscribeMode.endSubscribeMode(builder);
  }

  unpack(): SubscribeModeT {
    return new SubscribeModeT(this.subscriptionName());
  }

  unpackTo(_o: SubscribeModeT): void {
    _o.subscriptionName = this.subscriptionName();
  }

  unpackFields(...fields: string[]): SubscribeModeT {
    const t = new SubscribeModeT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("subscription_name")) {
      t.subscriptionName = this.subscriptionName();
    }
    return t;
  }
}

export class SubscribeModeT implements flatbuffers.IGeneratedObject {
  constructor(public subscriptionName: string | Uint8Array | null = null) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.subscriptionName === null || this.subscriptionName === undefined) {
      throw new Error('Required field "subscription_name" is not set');
    }
    const subscriptionName =
      this.subscriptionName !== null ? builder.createString(this.subscriptionName!) : 0;

    return SubscribeMode.createSubscribeMode(builder, subscriptionName);
  }

  clone(): SubscribeModeT {
    const obj = new SubscribeModeT();
    obj.subscriptionName = this.subscriptionName;
    return obj;
  }

  equals(other: SubscribeModeT): boolean {
    if (this.subscriptionName !== other.subscriptionName) return false;
    return true;
  }
}

export function verifySubscribeMode(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "subscription_name");
  } finally {
    verifier.popDepth();
  }
}
